import React, { FC, useCallback, useEffect, useState } from 'react'

import { Button, Col, Form, Input, PageHeader, Radio, Row, Table } from 'antd'
import { SelectFieldAnt } from 'Components/Form'
import { SelectItemProps } from 'Components/Form/Select'
import { useExportReport } from 'Hooks/useExportReport'
import FabricanteRastreador from 'Models/cadastros/FabricanteRastreador'
import Rastreador from 'Models/cadastros/Rastreador'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { ParamsRequest } from 'Services/__shared/types/resquest'
import WsCadastroService from 'Services/WS_CADASTRO'
import { ServiceListResponse } from 'Types/ServiceResponse'

import IFormRastreadoresFilter from './IFormRastreadoresFilter'

const ListRastreadores: FC = () => {
  const navigate = useNavigate()
  const hookForm = useForm()
  const [dataItens, setDataItens] = useState<
    ServiceListResponse<Rastreador> | undefined
  >()
  const [carregandoPesquisa, setCarregandoPesquisa] = useState<boolean>(false)
  const [carregandoExportacao, setCarregandoExportacao] =
    useState<boolean>(false)
  const [formulario] = Form.useForm<IFormRastreadoresFilter>()
  const [selectFabricanteItens, setSelectFabricanteItens] = useState<
    SelectItemProps[]
  >([])
  const [alturaTabela, setAlturaTabela] = useState<number>(
    window.innerHeight - 337,
  )

  window.addEventListener('resize', () =>
    setAlturaTabela(window.innerHeight - 337),
  )

  const getFabricantes = useCallback(async () => {
    const { data } = await WsCadastroService.rastreadores.getListFabricantes()

    if (data) {
      const selectFabricanteData: SelectItemProps[] = data.map(
        (item: FabricanteRastreador, i): SelectItemProps => {
          return {
            value: item.id.toString(),
            label: item.nome,
          }
        },
      )

      setSelectFabricanteItens(selectFabricanteData)
    }
  }, [])

  useEffect(() => {
    getFabricantes()
  }, [])

  const colunas = [
    {
      title: 'Número',
      key: 'numero',
      dataIndex: 'numero',
    },
    {
      title: 'Tecnologia',
      key: 'fabricante',
      dataIndex: 'fabricante',
      render: (fabricante: FabricanteRastreador) => fabricante.nome,
    },
    {
      title: 'Apelido',
      key: 'apelido',
      dataIndex: 'apelido',
    },
    {
      title: 'Localização',
      key: 'localizacao',
      dataIndex: 'localizacao',
    },
    {
      title: 'Data Posição',
      key: 'dtUltimaPosicao',
      dataIndex: 'dtUltimaPosicao',
    },
    {
      title: 'Identificação',
      key: 'placaVeiculo',
      dataIndex: 'placaVeiculo',
    },
    {
      title: 'Situação',
      key: 'ativo',
      dataIndex: 'ativo',
      render: (ativo: boolean) => (ativo ? 'ATIVO' : 'INATIVO'),
    },
  ]

  const pesquisaOuExportaRastreadores = async (
    filtros: IFormRastreadoresFilter,
  ) => {
    if (filtros.ativo === undefined) {
      filtros.ativo = true
    }

    if (carregandoPesquisa) {
      const { data } = await WsCadastroService.rastreadores.getListRastreadores(
        filtros,
      )
      setDataItens(data)
      setCarregandoPesquisa(false)
    } else {
      //await useExportReport.exportXLSX(WsCadastroService.empresas.export, 'Rastreadores', colunas, filtros)
      const colunasParaExportar =
        useExportReport.convertColumnToItemsList(colunas)
      const { data } = await WsCadastroService.rastreadores.export(
        filtros,
        undefined,
        { exportItemsList: colunasParaExportar },
      )

      if (data) {
        const a: any = document.createElement('A')
        a.href =
          'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; base64,' +
          data
        a.download = 'Rastreadores.xlsx'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }

      setCarregandoExportacao(false)
    }
  }

  const handleRowClick = (rowData?: Rastreador) => {
    navigate('/Rastreador/Alterar/' + rowData?.id)
  }

  const alteraPagina = async (numeroPagina: number, tamanhoPagina?: number) => {
    const parametros: ParamsRequest = {
      pageNumber: numeroPagina,
      pageSize: tamanhoPagina ?? 50,
    }

    const { data } = await WsCadastroService.rastreadores.getListRastreadores(
      formulario.getFieldsValue(),
      parametros,
    )
    setDataItens(data)
  }

  return (
    <>
      <Form
        onFinish={pesquisaOuExportaRastreadores}
        layout="vertical"
        form={formulario}
      >
        <PageHeader
          ghost={false}
          title="Consultar Rastreador"
          extra={[
            <Button
              key="pesquisa"
              type="primary"
              htmlType="submit"
              loading={carregandoPesquisa}
              onClick={() => setCarregandoPesquisa(true)}
            >
              Pesquisar
            </Button>,

            <Button
              key="exportacao"
              type="primary"
              htmlType="submit"
              loading={carregandoExportacao}
              onClick={() => setCarregandoExportacao(true)}
            >
              Exportar
            </Button>,

            <Button
              key="inclusao"
              type="primary"
              onClick={() => navigate('/Rastreador/Incluir')}
            >
              Incluir
            </Button>,

            <Button key="ajuda" type="primary">
              ?
            </Button>,
          ]}
        >
          <Row gutter={16}>
            <Col span={6} md={6} sm={12} xs={24}>
              <Form.Item name="numero" label="Número:">
                <Input type="text" />
              </Form.Item>
            </Col>

            <Col span={6} md={6} sm={12} xs={24}>
              <Form.Item name="apelido" label="Apelido:">
                <Input type="text" />
              </Form.Item>
            </Col>

            <Col span={6} md={6} sm={12} xs={24}>
              <SelectFieldAnt
                methods={hookForm}
                scope="form-rastreadores"
                label="Tecnologia:"
                name="cdFabricante"
                items={selectFabricanteItens}
                showSearch={true}
              />
            </Col>

            <Col span={6} md={6} sm={12} xs={24}>
              <Form.Item name="ativo" label="Situação:">
                <Radio.Group defaultValue={true}>
                  <Radio value={true}>Ativo</Radio>
                  <Radio value={false}>Inativo</Radio>
                  <Radio value={null}>Ambos</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Table
                columns={colunas}
                dataSource={dataItens?.items || []}
                scroll={{ y: alturaTabela }}
                onRow={(rowData: Rastreador) => {
                  return {
                    onClick: () => handleRowClick(rowData),
                  }
                }}
                pagination={{
                  pageSize: dataItens?.pagination?.pageSize,
                  total: dataItens?.pagination?.total,
                  onChange: alteraPagina,
                  onShowSizeChange: alteraPagina,
                  showSizeChanger: true,
                  pageSizeOptions: ['10', '25', '50', '75', '100'],
                  size: 'default',
                }}
              />
            </Col>
          </Row>
        </PageHeader>
      </Form>
    </>
  )
}

export default ListRastreadores
